import { DECK_ASSET_PACKS } from './assets/asset-packs';
import { FULL_DECK_CORE } from './derived/full-deck';
import { CARD_SEARCH_INDEX } from './indexes/search-index';
import { TAROT_CORPUS_MANIFEST, type TarotCorpusManifest } from './manifest';

export interface CorpusRegistry {
  manifest: TarotCorpusManifest;
  coreCount: number;
  libraryCount: number;
  assetPackCount: number;
  searchIndexCount: number;
}

export const TAROT_CORPUS_REGISTRY: CorpusRegistry = {
  manifest: TAROT_CORPUS_MANIFEST,
  coreCount: TAROT_CORPUS_MANIFEST.total_cards,
  libraryCount: FULL_DECK_CORE.length,
  assetPackCount: DECK_ASSET_PACKS.length,
  searchIndexCount: CARD_SEARCH_INDEX.length,
};
